import { gql } from '@apollo/client';

const REMOVE_SUPPLIER_ALIAS = gql`
  mutation RemoveSupplierAlias($supplierAliasId: Int!) {
    removeSiteSupplierAlias(supplierAliasId: $supplierAliasId)
  }
`;

export default REMOVE_SUPPLIER_ALIAS;
